import {
  FUNDS_TRANSACTION_PAGE_SIZE,
  FUNDS_TSTORE,
  TRANSACTION_SORT_ORDER,
} from "./recentTransactions/recentTransaction.constants";

// export const GET_TRANSACTIONS_URL = epoch =>
//   `apis/tstore/v3/units/changes?size=${FUNDS_TRANSACTION_PAGE_SIZE}&sortOrder=${
//     TRANSACTION_SORT_ORDER.DESC
//   }&fromTimestamp=${epoch}&viewId=${
//     FUNDS_TSTORE.VIEW ?? "phonepeSB__APPView"
//   }&viewVersion=${FUNDS_TSTORE.VIEW_VERSION ?? "7"}`;

export const GET_TRANSACTIONS_URL = epoch =>
  `apis/tstore/v3/units/changes?size=${FUNDS_TRANSACTION_PAGE_SIZE}&sortOrder=${TRANSACTION_SORT_ORDER.DESC}&fromTimestamp=${epoch}&viewId=${FUNDS_TSTORE.VIEW}&viewVersion=${FUNDS_TSTORE.VIEW_VERSION}`;

export const GET_ORDERS_URL = "apis/oms/v2/orders/fetch";
